var map = {
	"app/shell/ShellModule": [
		"./src/app/shell/ShellModule.ts",
		"common",
		"app-shell-ShellModule"
	],
	"app/shell/views/accounts/AccountViewModule": [
		"./src/app/shell/views/accounts/AccountViewModule.ts",
		"common",
		"app-shell-views-accounts-AccountViewModule"
	],
	"app/shell/views/clients/ClientViewModule": [
		"./src/app/shell/views/clients/ClientViewModule.ts",
		"common",
		"app-shell-views-clients-ClientViewModule"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;